var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[(_vm.show)?_c('div',{ref:"overlay",staticClass:"ui-modal overlay component",on:{"click":_vm.onClickOverlay}},[_c('div',{staticClass:"modal-content",style:({
        width: _vm.width + 'px',
        height: _vm.height ? _vm.height + 'px' : 'auto'
      })},[_c('SmartAssetEditor',{attrs:{"isAdminTemplate":_vm.isAdminTemplate,"editData":_vm.editData},on:{"edit:reset":_vm.reset,"page:refresh":_vm.refreshAsset,"create:success":_vm.createAsset}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }